import { usefulLinkState } from './useful-link.state';
import { usefulLinkActions } from './useful-link.action';
import { usefulLinkMutations } from './useful-link.mutation';

export default {
  namespaced: true,
  state: usefulLinkState,
  getters: {},
  actions: usefulLinkActions,
  mutations: usefulLinkMutations,
};
